import { AxiosInstance } from "axios";
import VuetifySelectItems from '@/types/app/vuetifySelectItems';
import Endpoint from '@/utils/endpoint';
import compareTo from '@/utils/compareTo';

interface ProductFund {
    fundName: string;
    fundSiteName: string;
    fundId: string;
}

interface ResponseData {
    hasAccount: boolean;
}

interface ProductSelectValue {
    id: string;
    title: string;
    is506c?: boolean;
}

export default class WalletService {
    // @Getter('getSelectProductsState', { namespace: 'wallet' }) selectedProducts!: VuetifySelectItems[];

    // @Getter('getSelectFundsState', { namespace: 'wallet' }) selectedFunds!: VuetifySelectItems[];

    // @Action("setSelectProductsState", { namespace: 'wallet' })
    // setSelectProductsState!: (selectedProducts: VuetifySelectItems[]) => void;

    // @Action("setSelectFundsState", { namespace: 'wallet' })
    // setSelectFundsState!: (selectedFunds: VuetifySelectItems[]) => void;
    constructor(
        private http: AxiosInstance,
        private endpoint: Endpoint = new Endpoint()
    ) { }


    async getProductFunds(all = false): Promise<VuetifySelectItems[]> {
        //if (this.selectedFunds.length <= 0) {
        const url = this.endpoint.productFund;
        const filter = all ? '' : '?hasInvestment=true';
        const response = await this.http.get(`${url}${filter}`);
        const productFunds = response.data as ProductFund[];
        const productFundsOrdened = productFunds.sort((a, b) =>
            compareTo(a.fundSiteName, b.fundSiteName)
        );

        const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
            text: productFund.fundSiteName,
            value: productFund.fundId,
            data: productFund,
        }));
        return itemsForVuetifySelect;
        //     this.setSelectFundsState(itemsForVuetifySelect);
        // }
        // return this.selectedFunds;
    }

    async getProducts(all = false): Promise<VuetifySelectItems[]> {
        // if (this.selectedProducts.length <= 0) {
        
        let itemsForVuetifySelect:any[] = []
        try {
            const url = this.endpoint.productsOnlyPublished;
            const filter = all ? '' : '&pastOnly=false';
            const response = await this.http.get(`${url} ${filter}`);
            const productFunds = response.data as ProductSelectValue[];
            if (productFunds) {
                const productFundsOrdened = productFunds.sort((a, b) =>
                    compareTo(a.title, b.title)
                );

                itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
                    text: productFund.title,
                    value: productFund.id,
                    data: productFund,
                }));

                return itemsForVuetifySelect;
            }

        } catch (error) {
            console.log(error);
        }
         
        return itemsForVuetifySelect; 

        //     this.setSelectProductsState(itemsForVuetifySelect);
        // }
        // return this.selectedProducts;
    }
}